import { ITransferGradesDatasource } from '../datasources/transfer_grades_datasource';
import * as _4 from 'lodash4';

angular
  .module('capability-ng-transfer')
  .service('ngDisplayGradeService', (ngTransferGradesDatasource: ITransferGradesDatasource) => {
    return (gradeNK: string, defaultValue: string = '') => {
      const grade = _4.find(ngTransferGradesDatasource.read(), { nk: gradeNK });
      return !!grade ? grade.grade_letter : defaultValue;
    };
  });



// WEBPACK FOOTER //
// ./app/lib/transfer/services/display_grade_service.ts